// extracted by mini-css-extract-plugin
export default {"main":"MobileNavigation_main__JwJfR","list":"MobileNavigation_list__EWvtL","active":"MobileNavigation_active__U5rXU","menuClose":"MobileNavigation_menuClose__PgGbh"};